"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
type PlayerRow = {
  name: string;
  dismissal?: string; // small subtext
  r: string | number; // runs
  b: string | number; // balls
  four: string | number; // 4s
  six: string | number; // 6s
  sr: string | number; // strike rate
};

// Dynamic JSON data
const BATTING_TABLE: {
  headingLeft: string;
  columns: string[];
  players: PlayerRow[];
  extras: string;
  total: string;
} = {
  headingLeft: "எம்ஐ பேட்டிங்",
  columns: ["ஆர்", "பி", "4கள்", "6கள்", "எஸ்/ஆர்"],
  players: [{
    name: "வி. கோஹ்லி",
    dismissal: "கேட் ப பிள்ளையின் ப",
    r: 57,
    b: 12,
    four: 4,
    six: 4,
    sr: 125.53
  }, {
    name: "வி. கோஹ்லி",
    dismissal: "கேட் ப பிள்ளையின் ப",
    r: 57,
    b: 12,
    four: 4,
    six: 4,
    sr: 125.53
  }, {
    name: "வி. கோஹ்லி",
    dismissal: "கேட் ப பிள்ளையின் ப",
    r: 57,
    b: 12,
    four: 4,
    six: 4,
    sr: 125.53
  }, {
    name: "வி. கோஹ்லி",
    dismissal: "கேட் ப பிள்ளையின் ப",
    r: 57,
    b: 12,
    four: 4,
    six: 4,
    sr: 125.53
  }, {
    name: "வி. கோஹ்லி",
    r: "-",
    b: "-",
    four: "-",
    six: "-",
    sr: "-"
  }, {
    name: "வி. கோஹ்லி",
    r: "-",
    b: "-",
    four: "-",
    six: "-",
    sr: "-"
  }, {
    name: "வி. கோஹ்லி",
    r: "-",
    b: "-",
    four: "-",
    six: "-",
    sr: "-"
  }, {
    name: "வி. கோஹ்லி",
    r: "-",
    b: "-",
    four: "-",
    six: "-",
    sr: "-"
  }, {
    name: "வி. கோஹ்லி",
    r: "-",
    b: "-",
    four: "-",
    six: "-",
    sr: "-"
  }, {
    name: "வி. கோஹ்லி",
    r: "-",
    b: "-",
    four: "-",
    six: "-",
    sr: "-"
  }],
  extras: "12 ( W 7, LB 3, NB 3)",
  total: "127/3"
};
export default function TeamPlayersPointsTable(t0) {
  const $ = _c(6);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = "w-full overflow-hidden bg-FFFFFF " + className;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="px-4 sm:px-6 py-4 bg-012061 text-FFFFFF grid grid-cols-[minmax(220px,1fr)_64px_64px_64px_64px_96px]"><div className="text-16-tamil-700 text-FFFFFF  line-clamp-1">{BATTING_TABLE.headingLeft}</div>{BATTING_TABLE.columns.map(_temp)}</div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = BATTING_TABLE.players.map(_temp2);
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="grid grid-cols-[minmax(220px,1fr)_64px_64px_64px_64px_96px] px-4 sm:px-6 py-3 border-t border-DCDCDC border-t bg-F8F8F8"><div className="text-16-tamil-600 text-1B1B1B line-clamp-1">சூடுதல்</div><div className="col-span-5 text-right text-16-english-600 text-1B1B1B leading-[1.5] line-clamp-1">{BATTING_TABLE.extras}</div></div>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="overflow-x-auto"><div className="min-w-[680px]">{t4}{t5}<div className="px-4 sm:px-6 py-3 bg-2D497E text-FFFFFF grid grid-cols-[minmax(220px,1fr)_64px_64px_64px_64px_96px]"><div className="text-16-tamil-600 text-FFFFFF line-clamp-1">மொத்த ரன்கள்</div><div className="col-span-5 text-right text-16-english-600 text-FFFFFF leading-[1.5] line-clamp-1">{BATTING_TABLE.total}</div></div></div></div>;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t2) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[4] = t2;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
}
function _temp2(p, idx) {
  return <div key={idx} className={"grid grid-cols-[minmax(220px,1fr)_64px_64px_64px_64px_96px] items-center " + (idx < 4 ? " bg-ECEEF3" : " bg-F8F8F8") + " px-4 sm:px-6 h-[75px] border-t border-DCDCDC"}><div className="flex flex-col justify-center"><span className="text-16-tamil-600 text-1B1B1B line-clamp-1">{p.name}</span>{p.dismissal && <span className="text-12-tamil-400 text-3D3D3D line-clamp-1">{p.dismissal}</span>}</div><Cell value={p.r} /><Cell value={p.b} /><Cell value={p.four} /><Cell value={p.six} /><Cell value={p.sr} /></div>;
}
function _temp(c, i) {
  return <div key={i} className="text-center text-14-tamil-500 text-FFFFFF line-clamp-1">{c}</div>;
}
function Cell(t0) {
  const $ = _c(2);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <div className="text-center text-16-english-600 text-1B1B1B leading-[1.5] line-clamp-1">{value}</div>;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}